export function convertObjectArrayToString(
    arr: { [key: string]: any }[],
    propertyWhitelist?: string[],
    propertyEscapeBlacklist?: string[],
): string {
    const stringArray: string[] = [];

    for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        const stringObjectArray: string[] = [];

        const keys = Object.keys(item);

        for (let j = 0; j < keys.length; j++) {
            const key = keys[j];

            if (item[key] === undefined) {
                continue;
            }

            let stringAccumulator: string | undefined;

            // TODO: If optimizing for performance move this outside the 'for's; This creates quite a bit of duplicate code but is faster
            if (Array.isArray(propertyWhitelist)) {
                if (propertyWhitelist.includes(key)) {
                    stringAccumulator = `${item[key]}`; // Convert to string
                }
            } else {
                stringAccumulator = `${item[key]}`;
            }

            if (stringAccumulator) {
                if (!(Array.isArray(propertyEscapeBlacklist) && propertyEscapeBlacklist.includes(key))) {
                    stringAccumulator = quoteString(stringAccumulator) as string;
                }

                stringAccumulator = `${key}: ${stringAccumulator}`;
                stringObjectArray.push(stringAccumulator);
            }
        }

        stringArray.push(`{ ${stringObjectArray.join(', ')} }`);
    }

    return `[ ${stringArray.join(', ')} ]`;
}

function quoteString(potentialString: unknown): unknown {
    return typeof potentialString === 'string' ? `"${potentialString}"` : potentialString;
}
